var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.939 6c3.886 0 6.572 1.846 8.061 5.538l-.127.304c-1.512 3.49-4.156 5.235-7.934 5.235-3.777 0-6.384-1.745-7.819-5.235L4 11.538C5.407 7.846 8.054 6 11.939 6M12 8a3.5 3.5 0 10-.001 6.999A3.5 3.5 0 0012 8m0 1.692a1.847 1.847 0 11-.001 3.693A1.847 1.847 0 0112 9.692",
    fill: "#C8C8C8",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyes);
export default __webpack_public_path__ + "static/media/ic_eyes.b66165f4990593c19bdb5d0a31fa495a.svg";
export { ForwardRef as ReactComponent };